import {DeliveryType} from './delivery-type';

export const DeliveryModel = {
    packageToMall: {deliveryType: DeliveryType.POST_OFFICE, price: 125},

};
